import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Grid, Row, Col } from 'react-flexbox-grid'
import FontAwesomeIcon from 'react-fontawesome'
import { HashLink as NavLink } from 'react-router-hash-link'

import { Mobile, Desktop } from '../Responsive'
import logo from './images/logo.png'
import IconData from '../IconData'

import './style.css'

const navItems = [
  { label: 'Állatorvosaink', url: '/#vets' },
  { label: 'Szolgáltatások', url: '/#services' },
  { label: 'Árlista', url: '/arak' },
  { label: 'Kutyakozmetika', url: '/kutyakozmetika' },
  { label: 'Hírek', url: '/hirek' },
  { label: 'Kapcsolat', url: '/#contact' },
]

export default class NavigationView extends Component {
  render() {
    return (
      <div className="navigationWrapper">
        <nav className="Navigation">
          <Grid>
            <Row between="xs">
              <Col xs>
                <div className="logoCol">
                  <Link to="/">
                    <img src={logo} className="logo" alt="logo" />
                  </Link>
                </div>
              </Col>
              <Desktop>
                <Col xs>
                  <ul className="navList">
                    {navItems.map((navItem, i) => (
                      <li className="navItem" key={i}>
                        <NavLink to={navItem.url} activeclassname="active">
                          {navItem.label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </Col>
              </Desktop>
              <Mobile>
                <Col xs>
                  <div className="hamburgerCol">
                    <div className="bookingButton">
                      <a
                        href="https://budavet.booked4.us/public/"
                        target="_blank">
                        <IconData name="calendar">Időpontfoglalás</IconData>
                      </a>
                    </div>
                  </div>
                </Col>
              </Mobile>
              <Mobile>
                <Col xs={2}>
                  <div className="hamburgerCol" onClick={this.props.toggleMenu}>
                    <FontAwesomeIcon
                      name="bars"
                      size="2x"
                      className="hamburgerIcon"
                    />
                  </div>
                </Col>
              </Mobile>
            </Row>
            <Desktop>
              <Row className="booking">
                <Col xs={9} />
                <Col xs={3} className="bookingButtonWrapper">
                  <div className="bookingButton inverted">
                    <a
                      href="https://budavet.booked4.us/public/"
                      target="_blank">
                      <IconData name="calendar">Időpontfoglalás</IconData>
                    </a>
                  </div>
                </Col>
              </Row>
            </Desktop>
          </Grid>
        </nav>
        {this.props.isOpen && (
          <Mobile>
            <div className="hamburgerMenu">
              {navItems.map((navItem, i) => (
                <NavLink to={navItem.url} key={i}>
                  <div className="navItem" onClick={this.props.toggleMenu}>
                    {navItem.label}
                  </div>
                </NavLink>
              ))}
            </div>
          </Mobile>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationView.js